/**
 * Layout for cookie icon
 *
 * @param {string} className
 * @return {string}
 */
const cookieIcon = (className = '') => (`
  <svg class="cookie-icon ${className}" aria-labelledby="cookie-title" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title id="cookie-title">cookie</title>
    <svg>
      <path fill-rule="evenodd" d="M21.963 12.023H22c-.02 5.515-4.49 9.981-10 9.981-5.523 0-10-4.487-10-10.02C2 6.74 6.019 2.438 11.139 2a5.46 5.46 0 005.38 4.62 5.445 5.445 0 005.444 5.403zM8 10a1 1 0 100-2 1 1 0 000 2zm6 1.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM9.5 18a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm8.5-2.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z" clip-rule="evenodd"></path>
      <path d="M18 3a1 1 0 11-2 0 1 1 0 012 0zm4 3.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z"></path>
    </svg>
  </svg>
`)

/**
 * Layout for GDPR banner
 *
 * @param {string} headline Headline text
 * @param {string} text Main text
 * @param {string} link Text for a link
 * @param {string} buttonText Text for a button
 * @param {string} cookieUrl URL of the info about cookies
 * @return {string}
 */
const layout = (
  headline,
  text,
  link,
  buttonText,
  cookieUrl
) => (`
  <div class="gdpr-container">
    ${cookieIcon('hide-small')}
    <div class="gdpr-banner-content">
      <div class="gdpr-banner-icon-small">
        ${cookieIcon()}
      </div>
      <div class="gdpr-banner-body">
        <div class="inner-body">
          <h2 class="gdpr-banner-headline">${headline}</h2>
          <p class="gdpr-banner-text">${text}</p>
         </div>
      </div>
      <div class="gdpr-banner-button-wrapper">
        <button type="button" class="gdpr-banner-btn">
          ${buttonText}
        </button>
      </div>
      <div class="gdpr-banner-link-wrapper">
        <a href="${cookieUrl}" class="gdpr-banner-link">
          ${link}
        </a>
      </div>
    </div>
  </div>
`)

/**
 * Append banner to <body> element
 *
 * @param {string} containerId Banner container id
 * @param {string} headline Headline text
 * @param {string} text Main text
 * @param {string} link Text for a link
 * @param {string} buttonText Text for a button
 * @param {string} cookieUrl URL of the info about cookies
 * @return HTMLElement
 */
export const appendBanner = (
  containerId,
  headline,
  text,
  link,
  buttonText,
  cookieUrl
) => {
  const body = document.getElementsByTagName('body')[0] || null
  if (!body) {
    throw Error('HTML Body not found.')
  }

  const banner = document.getElementById(containerId)
  const bannerExists = !!banner

  const bannerContainer = bannerExists
    ? banner
    : document.createElement('div')

  bannerContainer.setAttribute('id', containerId)
  bannerContainer.setAttribute('class', 'gdpr-banner')
  bannerContainer.innerHTML = layout(headline, text, link, buttonText, cookieUrl)

  if (!bannerExists) {
    body.appendChild(bannerContainer)
  }

  return bannerContainer
}

/**
 * Append css style into <head> element
 *
 * @param {string} href Full url of CSS file
 * @return void
 */
export const appendStyles = (href) => {
  const head = document.getElementsByTagName('head')[0] || null
  if (!head) {
    throw Error('HTML Head not found.')
  }

  const link = document.createElement('link')
  link.setAttribute('type', 'text/css')
  link.setAttribute('rel', 'stylesheet')
  link.setAttribute('href', href)

  head.appendChild(link)
}

/**
 * Hides a GDPR banner
 *
 * @param {HTMLElement} banner - An HTML element object
 * @return void
 */
export const closeBanner = (banner) => {
  banner.style.setProperty('display', 'none', 'important')
}
